var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _path110, _path111, _path112, _path113, _path114, _path115, _path116, _path117, _path118, _path119, _path120, _path121, _path122, _path123, _path124, _path125, _path126, _path127, _path128, _path129, _path130, _path131, _path132, _path133, _path134, _path135, _path136, _path137, _path138, _path139, _path140, _path141, _path142, _path143, _path144, _path145, _path146, _path147, _path148, _path149, _path150, _path151, _path152, _path153, _path154, _path155;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgThumbnail1A(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 328,
    height: 225,
    viewBox: "0 0 328 225",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M328 0H0V225H328V0Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M56.4194 18.0435H8.60608V22.7704H56.4194V18.0435Z",
    fill: "#E0E0E0"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M161.583 18.0435H113.77V22.7704H161.583V18.0435Z",
    fill: "#E0E0E0"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M108.988 18.0435H61.1749V22.7704H108.988V18.0435Z",
    fill: "#E0E0E0"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M214.155 18.0435H166.342V22.7704H214.155V18.0435Z",
    fill: "#E0E0E0"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M29.644 63.5137H8.60608V71.1668H29.644V63.5137Z",
    stroke: "#CCCCCC"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M29.644 132.389H8.60608V140.042H29.644V132.389Z",
    stroke: "#CCCCCC"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M29.644 55.8584H8.60608V63.5115H29.644V55.8584Z",
    fill: "#EEEEEE",
    stroke: "#CCCCCC"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M29.644 71.1655H8.60608V78.8186H29.644V71.1655Z",
    stroke: "#CCCCCC"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M29.644 140.046H8.60608V147.699H29.644V140.046Z",
    stroke: "#CCCCCC"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M29.644 78.8179H8.60608V86.4708H29.644V78.8179Z",
    stroke: "#CCCCCC"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M29.644 147.697H8.60608V155.35H29.644V147.697Z",
    stroke: "#CCCCCC"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M29.644 86.4722H8.60608V94.1253H29.644V86.4722Z",
    stroke: "#CCCCCC"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M29.644 155.348H8.60608V163.001H29.644V155.348Z",
    stroke: "#CCCCCC"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M29.644 109.431H8.60608V117.084H29.644V109.431Z",
    stroke: "#CCCCCC"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M29.644 178.306H8.60608V185.959H29.644V178.306Z",
    stroke: "#CCCCCC"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M29.644 94.124H8.60608V101.777H29.644V94.124Z",
    stroke: "#CCCCCC"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M29.644 163.005H8.60608V170.658H29.644V163.005Z",
    stroke: "#CCCCCC"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M29.644 117.086H8.60608V124.739H29.644V117.086Z",
    stroke: "#CCCCCC"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M29.644 185.959H8.60608V193.612H29.644V185.959Z",
    stroke: "#CCCCCC"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M29.644 201.27H8.60608V208.923H29.644V201.27Z",
    stroke: "#CCCCCC"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M29.644 101.775H8.60608V109.428H29.644V101.775Z",
    stroke: "#CCCCCC"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M29.644 170.657H8.60608V178.31H29.644V170.657Z",
    stroke: "#CCCCCC"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M29.644 124.738H8.60608V132.391H29.644V124.738Z",
    stroke: "#CCCCCC"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M29.644 193.614H8.60608V201.267H29.644V193.614Z",
    stroke: "#CCCCCC"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M29.644 208.921H8.60608V216.574H29.644V208.921Z",
    stroke: "#CCCCCC"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M150.134 63.5137H117.62V71.1668H150.134V63.5137Z",
    stroke: "#CCCCCC"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M150.134 132.389H117.62V140.042H150.134V132.389Z",
    stroke: "#CCCCCC"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M150.134 55.8584H117.62V63.5115H150.134V55.8584Z",
    fill: "#EEEEEE",
    stroke: "#CCCCCC"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M150.134 71.1655H117.62V78.8186H150.134V71.1655Z",
    stroke: "#CCCCCC"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M150.134 140.046H117.62V147.699H150.134V140.046Z",
    stroke: "#CCCCCC"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M150.134 78.8179H117.62V86.4708H150.134V78.8179Z",
    stroke: "#CCCCCC"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M150.134 147.697H117.62V155.35H150.134V147.697Z",
    stroke: "#CCCCCC"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M150.134 86.4722H117.62V94.1253H150.134V86.4722Z",
    stroke: "#CCCCCC"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M150.134 155.348H117.62V163.001H150.134V155.348Z",
    stroke: "#CCCCCC"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M150.134 109.431H117.62V117.084H150.134V109.431Z",
    stroke: "#CCCCCC"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M150.134 178.306H117.62V185.959H150.134V178.306Z",
    stroke: "#CCCCCC"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M150.134 94.124H117.62V101.777H150.134V94.124Z",
    stroke: "#CCCCCC"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M150.134 163.005H117.62V170.658H150.134V163.005Z",
    stroke: "#CCCCCC"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M150.134 117.086H117.62V124.739H150.134V117.086Z",
    stroke: "#CCCCCC"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M150.134 185.959H117.62V193.612H150.134V185.959Z",
    stroke: "#CCCCCC"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M150.134 201.27H117.62V208.923H150.134V201.27Z",
    stroke: "#CCCCCC"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M150.134 101.775H117.62V109.428H150.134V101.775Z",
    stroke: "#CCCCCC"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M150.134 170.657H117.62V178.31H150.134V170.657Z",
    stroke: "#CCCCCC"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M150.134 124.738H117.62V132.391H150.134V124.738Z",
    stroke: "#CCCCCC"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M150.134 193.614H117.62V201.267H150.134V193.614Z",
    stroke: "#CCCCCC"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M150.134 208.921H117.62V216.574H150.134V208.921Z",
    stroke: "#CCCCCC"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M173.084 63.5137H150.134V71.1668H173.084V63.5137Z",
    stroke: "#CCCCCC"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M173.084 132.389H150.134V140.042H173.084V132.389Z",
    stroke: "#CCCCCC"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M173.084 55.8584H150.134V63.5115H173.084V55.8584Z",
    fill: "#EEEEEE",
    stroke: "#CCCCCC"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M173.084 71.1655H150.134V78.8186H173.084V71.1655Z",
    stroke: "#CCCCCC"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M173.084 140.046H150.134V147.699H173.084V140.046Z",
    stroke: "#CCCCCC"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M173.084 78.8179H150.134V86.4708H173.084V78.8179Z",
    stroke: "#CCCCCC"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M173.084 147.697H150.134V155.35H173.084V147.697Z",
    stroke: "#CCCCCC"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M173.084 86.4722H150.134V94.1253H173.084V86.4722Z",
    stroke: "#CCCCCC"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M173.084 155.348H150.134V163.001H173.084V155.348Z",
    stroke: "#CCCCCC"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M173.084 109.431H150.134V117.084H173.084V109.431Z",
    stroke: "#CCCCCC"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M173.084 178.306H150.134V185.959H173.084V178.306Z",
    stroke: "#CCCCCC"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M173.084 94.124H150.134V101.777H173.084V94.124Z",
    stroke: "#CCCCCC"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M173.084 163.005H150.134V170.658H173.084V163.005Z",
    stroke: "#CCCCCC"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M173.084 117.086H150.134V124.739H173.084V117.086Z",
    stroke: "#CCCCCC"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M173.084 185.959H150.134V193.612H173.084V185.959Z",
    stroke: "#CCCCCC"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M173.084 201.27H150.134V208.923H173.084V201.27Z",
    stroke: "#CCCCCC"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M173.084 101.775H150.134V109.428H173.084V101.775Z",
    stroke: "#CCCCCC"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M173.084 170.657H150.134V178.31H173.084V170.657Z",
    stroke: "#CCCCCC"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M173.084 124.738H150.134V132.391H173.084V124.738Z",
    stroke: "#CCCCCC"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M173.084 193.614H150.134V201.267H173.084V193.614Z",
    stroke: "#CCCCCC"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M173.084 208.921H150.134V216.574H173.084V208.921Z",
    stroke: "#CCCCCC"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M200.816 63.5137H173.084V71.1668H200.816V63.5137Z",
    stroke: "#CCCCCC"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M200.816 132.389H173.084V140.042H200.816V132.389Z",
    stroke: "#CCCCCC"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M200.816 55.8584H173.084V63.5115H200.816V55.8584Z",
    fill: "#EEEEEE",
    stroke: "#CCCCCC"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M200.816 71.1655H173.084V78.8186H200.816V71.1655Z",
    stroke: "#CCCCCC"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M200.816 140.046H173.084V147.699H200.816V140.046Z",
    stroke: "#CCCCCC"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M200.816 78.8179H173.084V86.4708H200.816V78.8179Z",
    stroke: "#CCCCCC"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M200.816 147.697H173.084V155.35H200.816V147.697Z",
    stroke: "#CCCCCC"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M200.816 86.4722H173.084V94.1253H200.816V86.4722Z",
    stroke: "#CCCCCC"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M200.816 155.348H173.084V163.001H200.816V155.348Z",
    stroke: "#CCCCCC"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M200.816 109.431H173.084V117.084H200.816V109.431Z",
    stroke: "#CCCCCC"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M200.816 178.306H173.084V185.959H200.816V178.306Z",
    stroke: "#CCCCCC"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M200.816 94.124H173.084V101.777H200.816V94.124Z",
    stroke: "#CCCCCC"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M200.816 163.005H173.084V170.658H200.816V163.005Z",
    stroke: "#CCCCCC"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M200.816 117.086H173.084V124.739H200.816V117.086Z",
    stroke: "#CCCCCC"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M200.816 185.959H173.084V193.612H200.816V185.959Z",
    stroke: "#CCCCCC"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M200.816 201.27H173.084V208.923H200.816V201.27Z",
    stroke: "#CCCCCC"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M200.816 101.775H173.084V109.428H200.816V101.775Z",
    stroke: "#CCCCCC"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M200.816 170.657H173.084V178.31H200.816V170.657Z",
    stroke: "#CCCCCC"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M200.816 124.738H173.084V132.391H200.816V124.738Z",
    stroke: "#CCCCCC"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "M200.816 193.614H173.084V201.267H200.816V193.614Z",
    stroke: "#CCCCCC"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    d: "M200.816 208.921H173.084V216.574H200.816V208.921Z",
    stroke: "#CCCCCC"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    d: "M296.443 63.5137H200.816V71.1668H296.443V63.5137Z",
    stroke: "#CCCCCC"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    d: "M296.443 132.389H200.816V140.042H296.443V132.389Z",
    stroke: "#CCCCCC"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    d: "M296.443 55.8584H200.816V63.5115H296.443V55.8584Z",
    fill: "#EEEEEE",
    stroke: "#CCCCCC"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    d: "M296.443 71.1655H200.816V78.8186H296.443V71.1655Z",
    stroke: "#CCCCCC"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    d: "M296.443 140.046H200.816V147.699H296.443V140.046Z",
    stroke: "#CCCCCC"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    d: "M296.443 78.8179H200.816V86.4708H296.443V78.8179Z",
    stroke: "#CCCCCC"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    d: "M296.443 147.697H200.816V155.35H296.443V147.697Z",
    stroke: "#CCCCCC"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    d: "M296.443 86.4722H200.816V94.1253H296.443V86.4722Z",
    stroke: "#CCCCCC"
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    d: "M296.443 155.348H200.816V163.001H296.443V155.348Z",
    stroke: "#CCCCCC"
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    d: "M296.443 109.431H200.816V117.084H296.443V109.431Z",
    stroke: "#CCCCCC"
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    d: "M296.443 178.306H200.816V185.959H296.443V178.306Z",
    stroke: "#CCCCCC"
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    d: "M296.443 94.124H200.816V101.777H296.443V94.124Z",
    stroke: "#CCCCCC"
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    d: "M296.443 163.005H200.816V170.658H296.443V163.005Z",
    stroke: "#CCCCCC"
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    d: "M296.443 117.086H200.816V124.739H296.443V117.086Z",
    stroke: "#CCCCCC"
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    d: "M296.443 185.959H200.816V193.612H296.443V185.959Z",
    stroke: "#CCCCCC"
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    d: "M296.443 201.27H200.816V208.923H296.443V201.27Z",
    stroke: "#CCCCCC"
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    d: "M296.443 101.775H200.816V109.428H296.443V101.775Z",
    stroke: "#CCCCCC"
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    d: "M296.443 170.657H200.816V178.31H296.443V170.657Z",
    stroke: "#CCCCCC"
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    d: "M296.443 124.738H200.816V132.391H296.443V124.738Z",
    stroke: "#CCCCCC"
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    d: "M296.443 193.614H200.816V201.267H296.443V193.614Z",
    stroke: "#CCCCCC"
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    d: "M296.443 208.921H200.816V216.574H296.443V208.921Z",
    stroke: "#CCCCCC"
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    d: "M319.394 63.5137H296.443V71.1668H319.394V63.5137Z",
    stroke: "#CCCCCC"
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    d: "M319.394 132.389H296.443V140.042H319.394V132.389Z",
    stroke: "#CCCCCC"
  })), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    d: "M319.394 55.8584H296.443V63.5115H319.394V55.8584Z",
    fill: "#EEEEEE",
    stroke: "#CCCCCC"
  })), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    d: "M319.394 71.1655H296.443V78.8186H319.394V71.1655Z",
    stroke: "#CCCCCC"
  })), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    d: "M319.394 140.046H296.443V147.699H319.394V140.046Z",
    stroke: "#CCCCCC"
  })), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    d: "M319.394 78.8179H296.443V86.4708H319.394V78.8179Z",
    stroke: "#CCCCCC"
  })), _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    d: "M319.394 147.697H296.443V155.35H319.394V147.697Z",
    stroke: "#CCCCCC"
  })), _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    d: "M319.394 86.4722H296.443V94.1253H319.394V86.4722Z",
    stroke: "#CCCCCC"
  })), _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    d: "M319.394 155.348H296.443V163.001H319.394V155.348Z",
    stroke: "#CCCCCC"
  })), _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    d: "M319.394 109.431H296.443V117.084H319.394V109.431Z",
    stroke: "#CCCCCC"
  })), _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    d: "M319.394 178.306H296.443V185.959H319.394V178.306Z",
    stroke: "#CCCCCC"
  })), _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    d: "M319.394 94.124H296.443V101.777H319.394V94.124Z",
    stroke: "#CCCCCC"
  })), _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    d: "M319.394 163.005H296.443V170.658H319.394V163.005Z",
    stroke: "#CCCCCC"
  })), _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
    d: "M319.394 117.086H296.443V124.739H319.394V117.086Z",
    stroke: "#CCCCCC"
  })), _path123 || (_path123 = /*#__PURE__*/React.createElement("path", {
    d: "M319.394 185.959H296.443V193.612H319.394V185.959Z",
    stroke: "#CCCCCC"
  })), _path124 || (_path124 = /*#__PURE__*/React.createElement("path", {
    d: "M319.394 201.27H296.443V208.923H319.394V201.27Z",
    stroke: "#CCCCCC"
  })), _path125 || (_path125 = /*#__PURE__*/React.createElement("path", {
    d: "M319.394 101.775H296.443V109.428H319.394V101.775Z",
    stroke: "#CCCCCC"
  })), _path126 || (_path126 = /*#__PURE__*/React.createElement("path", {
    d: "M319.394 170.657H296.443V178.31H319.394V170.657Z",
    stroke: "#CCCCCC"
  })), _path127 || (_path127 = /*#__PURE__*/React.createElement("path", {
    d: "M319.394 124.738H296.443V132.391H319.394V124.738Z",
    stroke: "#CCCCCC"
  })), _path128 || (_path128 = /*#__PURE__*/React.createElement("path", {
    d: "M319.394 193.614H296.443V201.267H319.394V193.614Z",
    stroke: "#CCCCCC"
  })), _path129 || (_path129 = /*#__PURE__*/React.createElement("path", {
    d: "M319.394 208.921H296.443V216.574H319.394V208.921Z",
    stroke: "#CCCCCC"
  })), _path130 || (_path130 = /*#__PURE__*/React.createElement("path", {
    d: "M117.62 63.5137H29.6439V71.1668H117.62V63.5137Z",
    stroke: "#CCCCCC"
  })), _path131 || (_path131 = /*#__PURE__*/React.createElement("path", {
    d: "M117.62 132.389H29.6439V140.042H117.62V132.389Z",
    stroke: "#CCCCCC"
  })), _path132 || (_path132 = /*#__PURE__*/React.createElement("path", {
    d: "M117.62 55.8584H29.6439V63.5115H117.62V55.8584Z",
    fill: "#EEEEEE",
    stroke: "#CCCCCC"
  })), _path133 || (_path133 = /*#__PURE__*/React.createElement("path", {
    d: "M117.62 71.1655H29.6439V78.8186H117.62V71.1655Z",
    stroke: "#CCCCCC"
  })), _path134 || (_path134 = /*#__PURE__*/React.createElement("path", {
    d: "M117.62 140.046H29.6439V147.699H117.62V140.046Z",
    stroke: "#CCCCCC"
  })), _path135 || (_path135 = /*#__PURE__*/React.createElement("path", {
    d: "M117.62 78.8179H29.6439V86.4708H117.62V78.8179Z",
    stroke: "#CCCCCC"
  })), _path136 || (_path136 = /*#__PURE__*/React.createElement("path", {
    d: "M117.62 147.697H29.6439V155.35H117.62V147.697Z",
    stroke: "#CCCCCC"
  })), _path137 || (_path137 = /*#__PURE__*/React.createElement("path", {
    d: "M117.62 86.4722H29.6439V94.1253H117.62V86.4722Z",
    stroke: "#CCCCCC"
  })), _path138 || (_path138 = /*#__PURE__*/React.createElement("path", {
    d: "M117.62 155.348H29.6439V163.001H117.62V155.348Z",
    stroke: "#CCCCCC"
  })), _path139 || (_path139 = /*#__PURE__*/React.createElement("path", {
    d: "M117.62 109.431H29.6439V117.084H117.62V109.431Z",
    stroke: "#CCCCCC"
  })), _path140 || (_path140 = /*#__PURE__*/React.createElement("path", {
    d: "M117.62 178.306H29.6439V185.959H117.62V178.306Z",
    stroke: "#CCCCCC"
  })), _path141 || (_path141 = /*#__PURE__*/React.createElement("path", {
    d: "M117.62 94.124H29.6439V101.777H117.62V94.124Z",
    stroke: "#CCCCCC"
  })), _path142 || (_path142 = /*#__PURE__*/React.createElement("path", {
    d: "M117.62 163.005H29.6439V170.658H117.62V163.005Z",
    stroke: "#CCCCCC"
  })), _path143 || (_path143 = /*#__PURE__*/React.createElement("path", {
    d: "M117.62 117.086H29.6439V124.739H117.62V117.086Z",
    stroke: "#CCCCCC"
  })), _path144 || (_path144 = /*#__PURE__*/React.createElement("path", {
    d: "M117.62 185.959H29.6439V193.612H117.62V185.959Z",
    stroke: "#CCCCCC"
  })), _path145 || (_path145 = /*#__PURE__*/React.createElement("path", {
    d: "M117.62 201.27H29.6439V208.923H117.62V201.27Z",
    stroke: "#CCCCCC"
  })), _path146 || (_path146 = /*#__PURE__*/React.createElement("path", {
    d: "M117.62 101.775H29.6439V109.428H117.62V101.775Z",
    stroke: "#CCCCCC"
  })), _path147 || (_path147 = /*#__PURE__*/React.createElement("path", {
    d: "M117.62 170.657H29.6439V178.31H117.62V170.657Z",
    stroke: "#CCCCCC"
  })), _path148 || (_path148 = /*#__PURE__*/React.createElement("path", {
    d: "M117.62 124.738H29.6439V132.391H117.62V124.738Z",
    stroke: "#CCCCCC"
  })), _path149 || (_path149 = /*#__PURE__*/React.createElement("path", {
    d: "M117.62 193.614H29.6439V201.267H117.62V193.614Z",
    stroke: "#CCCCCC"
  })), _path150 || (_path150 = /*#__PURE__*/React.createElement("path", {
    d: "M117.62 208.921H29.6439V216.574H117.62V208.921Z",
    stroke: "#CCCCCC"
  })), _path151 || (_path151 = /*#__PURE__*/React.createElement("path", {
    d: "M85.1075 8.58936H8.60608V13.3163H85.1075V8.58936Z",
    fill: "#E0E0E0"
  })), _path152 || (_path152 = /*#__PURE__*/React.createElement("path", {
    d: "M319.394 30.3325H8.60608V32.2233H319.394V30.3325Z",
    fill: "#E0E0E0"
  })), _path153 || (_path153 = /*#__PURE__*/React.createElement("path", {
    d: "M94.6702 41.6782H8.60608V46.4051H94.6702V41.6782Z",
    fill: "#E0E0E0"
  })), _path154 || (_path154 = /*#__PURE__*/React.createElement("path", {
    d: "M142.458 41.6782H99.4259V46.4051H142.458V41.6782Z",
    fill: "#E0E0E0"
  })), _path155 || (_path155 = /*#__PURE__*/React.createElement("path", {
    d: "M190.271 41.6782H147.24V46.4051H190.271V41.6782Z",
    fill: "#E0E0E0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgThumbnail1A);
export default __webpack_public_path__ + "static/media/thumbnail-1-a.2eb4fc2fff929be13d2dbe6925ca8477.svg";
export { ForwardRef as ReactComponent };